import CONFIG from '../config/config';
import { CustomerStatus } from '../shared/customerStatusToTranslationKey';
import { INBOUND_CHANNEL } from '../shared/inboundChannelToTranslationKey';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';
import { Sale } from './SalesAPI';

export type CustomerResponse = {
  customer: Customer,
};

export type CustomerMeetingEnriched = {
  meeting: any;
  paymentInfo?: {
    paymentStatus?: string;
    paymentAmount?: number;
    paymentCurrency?: string;
  };
  bookingTrackingUrl?: string;
}

export type Customer = {
  id?: string;
  name: string;
  surname: string;
  countryCode?: string;
  phone?: string;
  email?: string;
  status: CustomerStatus;
  employeeId?: string;
  attachments: string[];
  notes?: string;
  weddingDate?: string;
  inboundChannel?: INBOUND_CHANNEL;
  orders?: any[];
  meetings?: any[];
  enrichedMeetings?: CustomerMeetingEnriched[];
  sales?: Sale[];
}

type BodyApiResponse = Customer[];

type PaginatedResponse = {
  content: Customer[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
};

const CustomersAPI = {
  get: ({ employee, page = 0, size = 50, followUpOnly = false, status }: { employee?: string; page?: number; size?: number; followUpOnly?: boolean; status?: string }) => {
    const queryParams = new URLSearchParams();
    if (employee) queryParams.append("employee", employee);
    if (followUpOnly) queryParams.append("followUpOnly", "true");
    if (status) queryParams.append("status", status);
    queryParams.append("page", page.toString());
    queryParams.append("size", size.toString());
    return APIClient(CONFIG.API_ENDPOINT).get<PaginatedResponse>(`v1/customersCrm?${queryParams.toString()}`)
  },
  getById: (id: string) => APIClient(CONFIG.API_ENDPOINT).get<Customer>(`/v1/customersCrm/${id}`),
  search: (text: string) => APIClient(CONFIG.API_ENDPOINT).get<PaginatedResponse>(`v1/customersCrm?searchText=${text}&page=0&size=50`),
  add: (customer: Customer) => APIClient(CONFIG.API_ENDPOINT).post<Customer>(`/v1/customersCrm`, customer),
  update: (id: string, customer: Customer) => APIClient(CONFIG.API_ENDPOINT).put<Customer>(`/v1/customersCrm/${id}`, customer),
  remove: (id: string) => APIClient(CONFIG.API_ENDPOINT).delete<BodyApiResponse>(`/v1/customersCrm/${id}`),
};

export default CustomersAPI;
